export const MatrixUtil = {
    // Compute the adjugate of m
    adj: function(m) {
        return [
            m[4] * m[8] - m[5] * m[7],
            m[2] * m[7] - m[1] * m[8],
            m[1] * m[5] - m[2] * m[4],
            m[5] * m[6] - m[3] * m[8],
            m[0] * m[8] - m[2] * m[6],
            m[2] * m[3] - m[0] * m[5],
            m[3] * m[7] - m[4] * m[6],
            m[1] * m[6] - m[0] * m[7],
            m[0] * m[4] - m[1] * m[3],
        ]
    },

    // multiply two 3*3 matrices
    multmm: function(a, b) {
        var c = [],
            i

        for (i = 0; i < 3; i++) {
            for (var j = 0; j < 3; j++) {
                var cij = 0
                for (var k = 0; k < 3; k++) {
                    cij += a[3 * i + k] * b[3 * k + j]
                }
                c[3 * i + j] = cij
            }
        }
        return c
    },

    // multiply a 3*3 matrix and a 3-vector
    multmv: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
            m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
            m[6] * v[0] + m[7] * v[1] + m[8] * v[2],
        ]
    },

    // multiply a scalar and a 3*3 matrix
    multsm: function(s, m) {
        var matrix = []

        for (var i = 0, l = m.length; i < l; i++) {
            matrix.push(s * m[i])
        }

        return matrix
    },

    basisToPoints: function(x1, y1, x2, y2, x3, y3, x4, y4) {
        var m = [x1, x2, x3, y1, y2, y3, 1, 1, 1],
            v = MatrixUtil.multmv(MatrixUtil.adj(m), [x4, y4, 1])

        return MatrixUtil.multmm(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]])
    },

    project: function(m, x, y) {
        var v = MatrixUtil.multmv(m, [x, y, 1])
        return [v[0] / v[2], v[1] / v[2]]
    },

    general2DProjection: function(x1s, y1s, x1d, y1d, x2s, y2s, x2d, y2d, x3s, y3s, x3d, y3d, x4s, y4s, x4d, y4d) {
        var s = MatrixUtil.basisToPoints(x1s, y1s, x2s, y2s, x3s, y3s, x4s, y4s),
            d = MatrixUtil.basisToPoints(x1d, y1d, x2d, y2d, x3d, y3d, x4d, y4d),
            m = MatrixUtil.multmm(d, MatrixUtil.adj(s))

        /*
         *	Normalize to the unique matrix with m[8] == 1.
         * 	See: http://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
         */
        return MatrixUtil.multsm(1 / m[8], m)
    },
}

export const MatrixDomUtil = {
    is3dCapable: function() {
        var ua = navigator.userAgent,
            ie = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1,
            doc = document.documentElement,
            ie3d = ie && 'transition' in doc.style,
            webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix(),
            gecko3d = 'MozPerspective' in doc.style

        return webkit3d || gecko3d || ie3d
    },

    getMatrixString: function(m) {
        var is3d = MatrixDomUtil.is3dCapable(),
            /*
             * Since matrix3d takes a 4*4 matrix, we add in an empty row and column, which act as the identity on the z-axis.
             * See:
             *     http://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
             *     https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function#M.C3.B6bius'_homogeneous_coordinates_in_projective_geometry
             */
            matrix = [m[0], m[3], 0, m[6], m[1], m[4], 0, m[7], 0, 0, 1, 0, m[2], m[5], 0, m[8]],
            str = is3d ? 'matrix3d(' + matrix.join(',') + ')' : ''

        if (!is3d) {
            throw new Error('Your browser must support 3D CSS transforms.')
        }

        return str
    },

    getRotateString: function(angle, units) {
        var is3d = MatrixDomUtil.is3dCapable(),
            open = 'rotate' + (is3d ? '3d' : '') + '(',
            rotateString = (is3d ? '0, 0, 1, ' : '') + angle + units

        return open + rotateString + ')'
    },
}
